// 復習システム用のユーティリティ関数

const REVIEW_STORAGE_KEY = 'finnish-quiz-review-questions';

// 間違えた問題を復習リストに追加
export const addToReview = (question) => {
    const reviewQuestions = getReviewQuestions();
    
    // 既に存在するかチェック（重複を避ける）
    const exists = reviewQuestions.some(q => 
        q.word === question.word && q.japanese === question.japanese
    );
    
    if (!exists) {
        reviewQuestions.push({
            ...question,
            addedAt: new Date().toISOString(),
            reviewCount: 0,
            lastReviewed: null
        });
        saveReviewQuestions(reviewQuestions);
    }
};

// 復習リストから問題を削除（正解したとき）
export const removeFromReview = (question) => {
    const reviewQuestions = getReviewQuestions();
    const filteredQuestions = reviewQuestions.filter(q => 
        !(q.word === question.word && q.japanese === question.japanese)
    );
    saveReviewQuestions(filteredQuestions);
};

// 復習問題の一覧を取得
export const getReviewQuestions = () => {
    try {
        const stored = localStorage.getItem(REVIEW_STORAGE_KEY);
        return stored ? JSON.parse(stored) : [];
    } catch (error) {
        console.error('Error loading review questions:', error);
        return [];
    }
};

// 復習問題を保存
const saveReviewQuestions = (questions) => {
    try {
        localStorage.setItem(REVIEW_STORAGE_KEY, JSON.stringify(questions));
    } catch (error) {
        console.error('Error saving review questions:', error);
    }
};

// 復習問題の統計情報を取得
export const getReviewStats = () => {
    const reviewQuestions = getReviewQuestions();
    return {
        totalCount: reviewQuestions.length,
        categoryBreakdown: reviewQuestions.reduce((acc, q) => {
            const key = q.category || `${q.part_of_speech}-${q.difficulty}`;
            acc[key] = (acc[key] || 0) + 1;
            return acc;
        }, {}),
        oldestQuestion: reviewQuestions.length > 0 ? 
            reviewQuestions.reduce((oldest, q) => 
                new Date(q.addedAt) < new Date(oldest.addedAt) ? q : oldest
            ) : null
    };
};

// 復習問題の記録を更新
export const updateReviewRecord = (question) => {
    const reviewQuestions = getReviewQuestions();
    const updatedQuestions = reviewQuestions.map(q => {
        if (q.word === question.word && q.japanese === question.japanese) {
            return {
                ...q,
                reviewCount: q.reviewCount + 1,
                lastReviewed: new Date().toISOString()
            };
        }
        return q;
    });
    saveReviewQuestions(updatedQuestions);
};

// 復習データをクリア
export const clearReviewData = () => {
    localStorage.removeItem(REVIEW_STORAGE_KEY);
};